<div class="registration-widget-container">
  <p-tabView>
    <p-tabPanel header="Outing Search">

      <p-progressbar *ngIf="loadingStates.search" mode="indeterminate" [style]="{'height': '6px'}" />

      <p-stepper *ngIf="outing" [value]="activeStep">
        <p-step-list>
          <p-step [value]="1">Find Outing</p-step>
          <p-step [value]="2">Add Golfers</p-step>
          <p-step [value]="3">Review & Submit</p-step>
        </p-step-list>
      </p-stepper>

      <!-- Step 1: Find Outing -->
      <p-card *ngIf="activeStep === 1" class="registration-card">
        <ng-template pTemplate="header">
          <div class="p-3">
            <h4 class="m-0">Enter Outing Code</h4>
            <p class="text-muted mb-0 mt-1">Enter the outing code to view the outing details, sign up for the outing, and make payment</p>
          </div>
        </ng-template>
        <p-message *ngIf="messages" [severity]="messages.severity" [text]="messages.summary" [closable]="true"
          styleClass="w-full mb-3" (onClose)="messages = null" />
        <div class="grid">
          <div class="col-12 md:col-10">
            <input pInputText type="text" [(ngModel)]="registrationCode" placeholder="Enter Outing Code"
              class="w-full" (keydown.enter)="findOuting(); $event.preventDefault()" />
          </div>
          <div class="col-12 md:col-2 flex gap-2">
            <p-button icon="pi pi-search" (onClick)="findOuting()" [loading]="loadingStates.search"
              [disabled]="!registrationCode?.trim() || loadingStates.search" />
            <p-button *ngIf="registrationCode" icon="pi pi-times" severity="secondary" (onClick)="reset()" [rounded]="true" />
          </div>
        </div>
      </p-card>

      <!-- Step 2: Add Golfers -->
      <ng-container *ngIf="outing && activeStep === 2 && !isOutingPast">
        <p-card class="registration-card outing-details-card">
          <ng-template pTemplate="header">
            <div class="p-3 outing-info outing-info-light">
              <h4 class="m-0">{{ outing.outingName || 'Outing' }}</h4>
              <p-divider />
              <div class="outing-info">
                <div class="flex align-items-center gap-2 mb-1"><i class="pi pi-calendar"></i> {{ outing.startDate | date: 'longDate' }} {{ outing.startDate | date: 'shortTime' }}</div>
                <div class="flex align-items-center gap-2 mb-1" *ngIf="outing.courseName"><i class="pi pi-map-marker"></i> {{ outing.courseName }}</div>
                <div class="flex align-items-center gap-2 mb-1" *ngIf="outing.fullAddress"><i class="pi pi-map"></i> {{ outing.fullAddress }}</div>
                <div class="flex align-items-center gap-2"><i class="pi pi-dollar"></i> <strong>${{ outing.cost | number: '1.2-2' }} per player</strong></div>
              </div>
            </div>
          </ng-template>
        </p-card>

        <p-card class="registration-card">
          <ng-template pTemplate="header">
            <div class="p-3 flex justify-content-between align-items-center flex-wrap gap-2">
              <h4 class="m-0">Team Members</h4>
              <div class="flex align-items-center gap-2">
                <p-tag [value]="registrations.length + '/4'" severity="primary" />
              </div>
            </div>
          </ng-template>
          <p-message *ngIf="teamCaptainErrorMessage" severity="error" [text]="teamCaptainErrorMessage" [closable]="true"
            styleClass="w-full mb-3" (onClose)="teamCaptainErrorMessage = null" />

          <form [formGroup]="registrationForm">
            <ng-container formArrayName="registrations">
              <div *ngFor="let reg of registrations.controls; let i = index" [formGroupName]="i"
                class="golfer-card" [class.captain-selected]="selectedTeamCaptainIndex === i">
                <div class="flex align-items-start gap-2">
                  <div class="flex align-items-baseline gap-1" *ngIf="registrations.length > 1">
                    <p-checkbox [binary]="true" [inputId]="'captain-' + i" [ngModel]="selectedTeamCaptainIndex === i"
                      [ngModelOptions]="{standalone: true}" (onChange)="markTeamCaptain(i)"
                      [disabled]="!reg.get('firstName')?.value || !reg.get('lastName')?.value" />
                    <label [for]="'captain-' + i" class="text-sm">Team Captain</label>
                  </div>
                  <div class="flex-1 grid">
                    <div class="col-6">
                      <input pInputText formControlName="firstName" placeholder="First Name" class="w-full" />
                    </div>
                    <div class="col-6">
                      <input pInputText formControlName="lastName" placeholder="Last Name" class="w-full" />
                    </div>
                  </div>
                  <p-button *ngIf="registrations.length > 1" icon="pi pi-trash" severity="danger" [rounded]="true"
                    (onClick)="removeRegistration(i)" />
                </div>
              </div>
            </ng-container>

            <div *ngIf="registrations.length === 1 && hasSelectableTeamCaptain" class="mt-3 mb-3">
              <div class="font-semibold mb-2">How are you registering?</div>
              <div class="flex flex-column gap-2 mb-3">
                <div class="flex align-items-start gap-2">
                  <p-radioButton
                    name="singleTeamMode"
                    value="solo_captain"
                    [(ngModel)]="singleRegistrationTeamMode"
                    inputId="mode-solo"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onSingleRegistrationTeamModeChange($event)" />
                  <div>
                    <label for="mode-solo" class="cursor-pointer font-medium">I'm registering as team captain</label>
                    <div class="text-muted text-sm mt-1">You're the only player you're paying for; you'll lead the team.</div>
                  </div>
                </div>
                <div class="flex align-items-start gap-2">
                  <p-radioButton
                    name="singleTeamMode"
                    value="join_team"
                    [(ngModel)]="singleRegistrationTeamMode"
                    inputId="mode-join"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onSingleRegistrationTeamModeChange($event)" />
                  <div>
                    <label for="mode-join" class="cursor-pointer font-medium">Join an existing team</label>
                    <div class="text-muted text-sm mt-1">Choose the captain of the team you're joining.</div>
                  </div>
                </div>
              </div>
              <div *ngIf="singleRegistrationTeamMode === 'join_team'">
                <label class="block mb-2 font-semibold" for="teamCaptainSelect">Team captain</label>
                <p-select
                  inputId="teamCaptainSelect"
                  formControlName="teamCaptain"
                  [options]="teamCaptainSelectOptions"
                  optionLabel="label"
                  optionValue="value"
                  optionDisabled="disabled"
                  placeholder="Select team captain"
                  [showClear]="true"
                  styleClass="w-full" />
              </div>
              <small *ngIf="allTeamCaptainSlotsFull" class="block mt-2 text-red-500">All teams are full — you cannot join as a single player until a spot opens.</small>
            </div>

            <p-button *ngIf="registrations.length < 4" label="Add Golfer" icon="pi pi-plus" severity="secondary"
              (onClick)="addRegistration()" styleClass="mt-3" [disabled]="registrations.length >= 4" />

            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="reset()" styleClass="mt-3 w-full" />


            <p-button label="Continue to Review" (onClick)="continueToReview()" styleClass="mt-3 w-full"
              [disabled]="!canProceedToReview" />

          </form>
        </p-card>
      </ng-container>

      <!-- Step 3: Review -->
      <ng-container *ngIf="activeStep === 3 && outing && !isOutingPast">
        <p-card class="registration-card outing-details-card">
          <ng-template pTemplate="header">
            <div class="p-3 outing-info outing-info-light">
              <h4 class="m-0">{{ outing.outingName || 'Outing' }}</h4>
              <p-divider />
              <div class="outing-info">
                <div class="flex align-items-center gap-2 mb-1"><i class="pi pi-calendar"></i> {{ outing.startDate | date: 'longDate' }}</div>
                <div class="flex align-items-center gap-2 mb-1" *ngIf="outing.courseName"><i class="pi pi-map-marker"></i> {{ outing.courseName }}</div>
                <div class="flex align-items-center gap-2"><i class="pi pi-dollar"></i> ${{ outing.cost | number: '1.2-2' }} per player</div>
              </div>
            </div>
          </ng-template>
        </p-card>

        <p-card class="registration-card">
          <ng-template pTemplate="header">
            <div class="p-3">
              <h4 class="m-0">Review Registration</h4>
            </div>
          </ng-template>
          <p-message severity="info" text="Please review your registration details before submitting." styleClass="w-full mb-3" />

          <div class="mb-3" *ngIf="registrationForm.get('teamCaptain')?.value">
            <div class="text-muted text-sm mb-1">Team Captain</div>
            <div class="font-semibold">{{ registrationForm.get('teamCaptain')?.value }}</div>
          </div>
          <p-divider />

          <div class="mb-3">
            <div class="text-muted text-sm mb-2">Registered Golfers ({{ registrations.length }})</div>
            <div *ngFor="let reg of registrations.controls; let i = index" class="flex align-items-center gap-2 mb-1 p-2"
              [class.bg-primary-50]="selectedTeamCaptainIndex === i">
              <i *ngIf="selectedTeamCaptainIndex === i" class="pi pi-check-circle text-primary"></i>
              <span>{{ reg.get('firstName')?.value }} {{ reg.get('lastName')?.value }}</span>
              <p-tag *ngIf="selectedTeamCaptainIndex === i" value="Captain" severity="primary" styleClass="ml-1" />
            </div>
          </div>
          <p-divider />

          <div class="summary-section">
            <div class="text-muted text-sm mb-2 font-semibold">Summary</div>
            <div *ngFor="let reg of registrations.controls; let i = index" class="flex justify-content-between align-items-center mb-2 pb-2 summary-row">
              <div>
                <span class="font-medium">{{ reg.get('firstName')?.value }} {{ reg.get('lastName')?.value }}</span>
                <p-tag *ngIf="selectedTeamCaptainIndex === i" value="Captain" severity="primary" styleClass="ml-1" />
                <div class="text-muted text-sm">Registration Fee</div>
              </div>
              <span>${{ outing?.cost | number: '1.2-2' }}</span>
            </div>
            <p-divider />
            <div class="flex justify-content-between mb-1">
              <span class="text-muted">Subtotal ({{ registrations.length }} {{ registrations.length === 1 ? 'player' : 'players' }})</span>
              <span class="text-muted">${{ subtotal | number: '1.2-2' }}</span>
            </div>
            <div *ngIf="creditCardFeeAmount > 0" class="flex justify-content-between mb-1">
              <span class="text-muted">Credit Card Fee {{ outing?.creditCardFeeType === CreditCardFeeType.Percentage ? '(' + outing?.creditCardFee + '%)' : '' }}</span>
              <span class="text-muted">${{ creditCardFeeAmount | number: '1.2-2' }}</span>
            </div>
            <p-divider />
            <div class="flex justify-content-between font-bold">
              <span>Total</span>
              <span class="text-primary">${{ totalCost | number: '1.2-2' }}</span>
            </div>
          </div>

          <div class="flex flex-column gap-2 mt-3">
            <p-button label="Back to Edit" icon="pi pi-arrow-left" severity="secondary" (onClick)="backToEdit()" />
            <p-button label="Pay Now (${{ totalCost | number: '1.2-2' }})" icon="pi pi-credit-card" (onClick)="payNow()"
              [loading]="loadingStates.submit" />
            <p-button label="Email Registration Codes" icon="pi pi-envelope" severity="secondary" (onClick)="openEmailModal()" />
          </div>
        </p-card>
      </ng-container>

      <!-- Payment Step -->
      <p-card *ngIf="showPaymentStep && paymentIntent" class="registration-card">
        <ng-template pTemplate="header">
          <div class="p-3">
            <h3 class="m-0">Complete Payment</h3>
            <p class="text-muted mb-0 mt-1">Total: ${{ totalCost | number: '1.2-2' }}</p>
          </div>
        </ng-template>
        <p-progressbar *ngIf="loadingStates.payment" mode="indeterminate" [style]="{'height': '6px'}" />
        <div *ngIf="!loadingStates.payment && elementsOptions.clientSecret" class="mb-3">
          <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
            <ngx-stripe-payment [options]="paymentElementsOptions" (change)="onCardChange($event)" />
          </ngx-stripe-elements>
        </div>
        <div class="flex justify-content-between mt-3">
          <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="cancelPayment()" />
          <p-button [label]="'Pay $' + (totalCost | number: '1.2-2')" icon="pi pi-lock" (onClick)="confirmPayment()"
            [loading]="loadingStates.paymentSubmit" [disabled]="!isCardValid || loadingStates.paymentSubmit" />
        </div>
      </p-card>

      <!-- Email Modal -->
      <p-dialog header="Email Registration Codes" [visible]="isEmailModalOpen" [modal]="true" [closable]="!emailSending"
        (onHide)="closeEmailModal()" [style]="{width: '90vw', 'max-width': '400px'}">
        <p class="mb-3">Enter your email address. We'll send you the Player Registration Codes to make payment with your credit card.</p>
        <input pInputText type="email" [ngModel]="registrationForm.get('emailAddress')?.value" placeholder="Email Address" class="w-full mb-3" />
        <ng-template pTemplate="footer">
          <p-button label="Cancel" (onClick)="closeEmailModal()" [disabled]="emailSending" />
          <p-button label="Send Codes" (onClick)="submitEmailRegistration()" [loading]="emailSending"
            [disabled]="!registrationForm.get('emailAddress')?.value || emailSending" />
        </ng-template>
      </p-dialog>

      <!-- Payment Success Dialog -->
      <p-dialog header="Payment Successful!" [visible]="isPaymentSuccessOpen" [modal]="true" [closable]="true"
        (onHide)="closePaymentSuccess()" [style]="{width: '90vw', 'max-width': '400px'}">
        <div class="text-center">
          <i class="pi pi-check-circle text-green-600" style="font-size: 4rem"></i>
          <p class="mt-2">Your registration has been completed and payment has been processed successfully.</p>
          <div *ngIf="createdRegistrations.length > 0" class="mt-3 p-2 bg-gray-100 rounded">
            <div class="text-muted text-sm mb-1">Registered {{ createdRegistrations.length }} player{{ createdRegistrations.length > 1 ? 's' : '' }}:</div>
            <div *ngFor="let r of createdRegistrations">{{ r.firstName }} {{ r.lastName }}</div>
          </div>
        </div>
        <ng-template pTemplate="footer">
          <p-button label="Done" (onClick)="closePaymentSuccess()" />
        </ng-template>
      </p-dialog>
    </p-tabPanel>

    <p-tabPanel header="Player Registration Search">
      <p-progressbar *ngIf="loadingStates.playerSearch" mode="indeterminate" [style]="{'height': '6px'}" />

      <p-card class="registration-card">
        <ng-template pTemplate="header">
          <div class="p-3">
            <h3 class="m-0">Search Registration</h3>
            <p class="text-muted mb-0 mt-1">Enter your registration code to view details and make payment</p>
          </div>
        </ng-template>
        <p-message *ngIf="playerSearchError" severity="error" [text]="playerSearchError" [closable]="true"
          styleClass="w-full mb-3" (onClose)="playerSearchError = null" />
        <div class="grid mb-3">
          <div class="col-12 md:col-10">
            <input pInputText type="text" [(ngModel)]="playerRegistrationCode" placeholder="Enter Registration Code"
              class="w-full" (keydown.enter)="searchPlayerRegistration(); $event.preventDefault()"
              (input)="playerSearchError = null" />
          </div>
          <div class="col-12 md:col-2 flex gap-2">
            <p-button icon="pi pi-search" (onClick)="searchPlayerRegistration()" [loading]="loadingStates.playerSearch"
              [disabled]="!playerRegistrationCode?.trim() || loadingStates.playerSearch" />
            <p-button *ngIf="playerRegistrationCode" icon="pi pi-times" severity="secondary" (onClick)="resetPlayerSearch()" [rounded]="true" />
          </div>
        </div>

        <ng-container *ngIf="playerRegistration">
          <p-divider />
          <div class="flex justify-content-between align-items-center mb-2">
            <h4 class="m-0">Registration Details</h4>
            <p-tag [value]="playerRegistration.playerRegistrationCode" severity="primary" />
          </div>
          <p-divider />

          <div class="player-details-grid">
            <div class="flex align-items-center gap-2 mb-2">
              <i class="pi pi-user text-primary"></i>
              <div>
                <div class="text-muted text-sm">Player Name</div>
                <div class="font-semibold">{{ playerRegistration.firstName }} {{ playerRegistration.lastName }}</div>
              </div>
            </div>

            <div *ngIf="playerRegistration.teamCaptain" class="flex align-items-center gap-2 mb-2">
              <i class="pi pi-users text-primary"></i>
              <div>
                <div class="text-muted text-sm">Team Captain</div>
                <div class="font-semibold">{{ playerRegistration.teamCaptain }}</div>
              </div>
            </div>

            <div class="flex align-items-center gap-2 mb-2">
              <i class="pi" [ngClass]="playerRegistration.isCheckedIn ? 'pi-check-circle text-green-600' : 'pi-times-circle text-orange-600'"></i>
              <div>
                <div class="text-muted text-sm">Check-In Status</div>
                <div class="font-semibold" [ngClass]="playerRegistration.isCheckedIn ? 'text-green-600' : 'text-orange-600'">
                  {{ playerRegistration.isCheckedIn ? 'Checked In' : 'Needs to Check In' }}
                </div>
              </div>
            </div>

            <div class="flex align-items-center gap-2 mb-2">
              <i class="pi" [ngClass]="playerRegistration.hasPaid ? 'pi-check-circle text-green-600' : 'pi-times-circle text-orange-600'"></i>
              <div>
                <div class="text-muted text-sm">Payment Status</div>
                <div class="font-semibold" [ngClass]="playerRegistration.hasPaid ? 'text-green-600' : 'text-orange-600'">
                  {{ playerRegistration.hasPaid ? 'Paid' : 'Payment Needed' }}
                </div>
              </div>
            </div>

            <div class="flex align-items-center gap-2 mb-2">
              <i class="pi pi-dollar text-primary"></i>
              <div>
                <div class="text-muted text-sm">Registration Cost</div>
                <div class="font-semibold">${{ (playerRegistration.cost / 100) | number: '1.2-2' }}</div>
              </div>
            </div>

            <p-divider />

            <div *ngIf="!playerRegistration.hasPaid" class="mt-2">
              <p-button label="Pay Now" icon="pi pi-credit-card" (onClick)="payPlayerRegistration()"
                [loading]="loadingStates.payment" styleClass="w-full" />
            </div>
            <p-message *ngIf="playerRegistration.hasPaid" severity="success" text="Payment completed" styleClass="w-full mt-2" />
          </div>
        </ng-container>
      </p-card>

      <p-card *ngIf="showPlayerPaymentStep && playerPaymentIntent" class="registration-card mt-3">
        <ng-template pTemplate="header">
          <div class="p-3">
            <h3 class="m-0">Complete Payment</h3>
            <p class="text-muted mb-0 mt-1">Total: ${{ (playerRegistration?.cost || 0) / 100 | number: '1.2-2' }}</p>
          </div>
        </ng-template>
        <p-progressbar *ngIf="loadingStates.payment" mode="indeterminate" [style]="{'height': '6px'}" />
        <div *ngIf="!loadingStates.payment && elementsOptions.clientSecret" class="mb-3">
          <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
            <ngx-stripe-payment [options]="paymentElementsOptions" (change)="onCardChange($event)" />
          </ngx-stripe-elements>
        </div>
        <div class="flex justify-content-between mt-3">
          <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="cancelPlayerPayment()" />
          <p-button [label]="'Pay $' + playerPaymentAmount" icon="pi pi-lock" (onClick)="confirmPlayerPayment()"
            [loading]="loadingStates.paymentSubmit" [disabled]="!isCardValid || loadingStates.paymentSubmit" />
        </div>
      </p-card>
    </p-tabPanel>
  </p-tabView>
</div>
